module.exports = __webpack_public_path__ + "6841eb6e903ce67dde940dfe8da2af17.pdf";